import { reactive, toRefs } from "vue";

const state = reactive({
  visible: false,
  type: "info",
  title: "",
  message: "",
  duration: 3000,
});

let activeTimeout = null;

export const ToastService = {
  success(message, title = "Thành công") {
    this.show("success", message, title);
  },

  error(message, title = "Lỗi") {
    this.show("error", message, title);
  },

  warning(message, title = "Cảnh báo") {
    this.show("warning", message, title);
  },

  info(message, title = "Thông báo") {
    this.show("info", message, title);
  },

  show(type, message, title, duration = 3000) {
    if (activeTimeout) {
      clearTimeout(activeTimeout);
      activeTimeout = null;
    }

    state.type = type;
    state.message = message;
    state.title = title;
    state.duration = duration;
    state.visible = true;

    if (duration > 0) {
      activeTimeout = setTimeout(() => {
        this.close();
      }, duration);
    }

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, duration);
    });
  },

  close() {
    if (activeTimeout) {
      clearTimeout(activeTimeout);
      activeTimeout = null;
    }
    state.visible = false;
  },

  getState() {
    return toRefs(state);
  },
};
